import { z } from 'zod'

/** Why the backfill couldn't link an event on its own. Mirrors `GhlReviewReason` in the Prisma schema (`check:enums`). */
export const GHL_REVIEW_REASONS = ['clef_unsure', 'email_ambiguous', 'email_taken'] as const

export const ghlReviewReasonSchema = z.enum(GHL_REVIEW_REASONS)

export type GhlReviewReason = z.infer<typeof ghlReviewReasonSchema>
